import { render } from "./PrixVue.vue?vue&type=template&id=5dbb22d0"
import script from "./PrixVue.vue?vue&type=script&lang=js"
export * from "./PrixVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__